import React from "react";
import MasterLayout from "../masterLayout/MasterLayout";
import Breadcrumb from "../components/Breadcrumb";
import AddExpenseLayer from "../components/AddExpenseLayer";

const AddExpensePage = () => {
  return (
    <>
      <MasterLayout>
        <Breadcrumb title="Add Purchase Bill" />
        <AddExpenseLayer />
      </MasterLayout>
    </>
  );
};

export default AddExpensePage;
